import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {userRolesOptions} from '../../constants/userRolesOptions';
import {EditTeammate} from '../../../shared/states/profile/profile.actions';
import {take, withLatestFrom} from 'rxjs/operators';
import {Select, Store} from '@ngxs/store';
import {ProfileState} from '../../../shared/states/profile/profile.state';
import {Observable} from 'rxjs/internal/Observable';
import {ITeamRecord} from '../../interfaces/team-record.interface';
import {UserStatusEnum} from '../../../shared/interfaces/UserStatusEnum';

@Component({
  selector: 'app-edit-user-dialog',
  templateUrl: './edit-user-dialog.component.html',
  styleUrls: ['./edit-user-dialog.component.scss'],
})
export class EditUserDialogComponent implements OnInit {
  @Input() show: boolean;
  @Input() user: ITeamRecord;

  @Output() afterSaved: EventEmitter<any> = new EventEmitter();
  @Output() closeDialog: EventEmitter<void> = new EventEmitter();

  editUserForm: UntypedFormGroup = new UntypedFormGroup({});

  userRolesOptions = userRolesOptions;
  suspendUser: boolean;

  @ViewChild('lastNameInput') lastNameInput;
  @ViewChild('emailInput') emailInput;
  @ViewChild('roleDropdown') roleDropdown;

  @Select(ProfileState.success) success$: Observable<boolean>;
  @Select(ProfileState.editUserResponse) response$: Observable<any>;

  constructor(
    private fb: UntypedFormBuilder,
    private store: Store,
  ) {
    this.editUserForm = this.fb.group({
      id: ['', []],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      role: ['', [Validators.required]],
      status: [UserStatusEnum.Active, []],
    });
  }

  ngOnInit(): void {
    if (this.user) {
      this.editUserForm.patchValue(this.user);
      this.editUserForm.get('role').patchValue(this.userRolesOptions.find(el => this.user.role === el.id)?.id);
      this.suspendUser = this.user.status === UserStatusEnum.Suspended;
      this.editUserForm[this.suspendUser ? 'disable' : 'enable']();
    }
  }

  close(): void {
    this.closeDialog.emit();
  }

  edit(): void {
    const formValue = this.editUserForm.value;

    formValue.status = this.suspendUser ? UserStatusEnum.Suspended : UserStatusEnum.Active;
    formValue.createDate = new Date();

    this.store.dispatch(new EditTeammate(formValue))
      .pipe(take(1), withLatestFrom(this.success$, this.response$))
      .subscribe(([_, success, response]) => {
        if (response && response.message === 'Username Taken') {
          this.editUserForm.get('email').setErrors({emailTaken: true});
        } else {
          this.afterSaved.emit(success);
        }
      });
  }

  changeSuspend(): void {
    this.editUserForm[this.suspendUser ? 'enable' : 'disable']();
  }

  focusInput(inputName: string): void {
    setTimeout(() => this[inputName] && this[inputName]?.appInput?.nativeElement?.focus());
  }

  openDropdown(): void {
    this.roleDropdown.showDropdown = true;
  }
}
